/**
 * MSS补打卡 - 未审批点击的审核内页
 */


import React, { Component } from 'react';
import { Container } from 'flux/utils';

import { getItem as getLang } from '../../common/lang';

import Button from '../../components/Button/Button.jsx';
import FormControl from '../../components/FormControl/FormControl.jsx';
import Header from '../../components/Header/Header.jsx';
import InfoCard from '../../components/InfoCard/InfoCard.jsx';
import Loader from '../../components/Loader/Loader.jsx';
import TextInput from '../../components/TextInput/TextInput.jsx';

import RepairClockInStore from '../../stores/RepairClockInStore';
import RepairClockInDataUtils from '../../data-utils/RepairClockInDataUtils';


class RepairClockInPendingRecord extends Component {

	static getStores() {
		return [RepairClockInStore];
	}

	static calculateState() {
		return RepairClockInStore.getState();
	}

	constructor(props) {
		super(props);

		// OvertimeDataUtils.getEmpOtRecord(this.props.routeParams.id);
	}


	/**
	 * Approve a record
	 * @param {boolean} agreeOrNot
	 */
	approve(agreeOrNot) {
		RepairClockInDataUtils.mssApproveRecord({
			id: this.props.params.id,
			appOpinion: React.findDOMNode(this.refs.opinion).value,
			agreeOrNot
		});
	}


	render() {
		const {
				empOtRecord = {},
				status = 'loading'
			} = this.state,
			{
				baseInfo,
				appInfo
			} = empOtRecord;

		return (
			<div>
				<Header goBack title={getLang('MY_RCI')} />

				<div className='row gap-t'>
					<div className='col-1-1'>
						<FormControl label={getLang('APPROVE_OPINION')}>
							<TextInput ref='opinion' />
						</FormControl>
					</div>
				</div>

				<div className='row'>
					<div className='col-1-2'>
						<Button text={getLang('APPROVE')}
										onTouchTap={this.approve.bind(this, true)} />
					</div>
					<div className='col-1-2'>
						<Button hollow className='text-primary'
										text={getLang('REJECT')}
										onTouchTap={this.approve.bind(this, false)} />
					</div>
				</div>
			</div>
		);
	}
}


export default Container.create(RepairClockInPendingRecord);



// WEBPACK FOOTER //
// ./src/containers/RepairClockIn/RepairClockInMgrPendingRecordContainer.js